import React, { useEffect } from "react";

/**
 * Portal-crossing overlay.
 * Shows a brief cyan flash, a scan-band sweep, fades to near-black, then exits.
 * Total duration: ~750ms. Calls onComplete when done.
 */
const EnterTransition = ({ active, onComplete }) => {
  useEffect(() => {
    if (!active) return undefined;
    const t = setTimeout(() => onComplete?.(), 720);
    return () => clearTimeout(t);
  }, [active, onComplete]);

  return (
    <div
      className={`enter-overlay ${active ? "is-active" : ""}`}
      aria-hidden="true"
      data-testid="enter-transition"
    >
      {active ? (
        <>
          <div className="absolute inset-0 crt-scanlines opacity-80" />
          <div className="enter-scan-band" />
          <div
            className="absolute inset-0 pointer-events-none"
            style={{ boxShadow: "inset 0 0 220px rgba(0,0,0,0.85)" }}
          />
        </>
      ) : null}
    </div>
  );
};

export default EnterTransition;
